import { GET_COMMENTARY_ANALYSIS_DATA } from '../../common/actionTypes.js';

const INITIAL_STATE = {
  commentryAnalysisData: [],
};

const CommentryAnalysisReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_COMMENTARY_ANALYSIS_DATA: {
      return { ...state, commentryAnalysisData: action.payload };
    }
   
    default:
      return state;
  }
};

export default CommentryAnalysisReducer;
